const CDNImage = props => {
    const { image, size = 'small', style } = props;
    const src = `https://cdn${props.app.domain}/${props.app.account.directory}/${props.cdnPath}/${image.fileName}`;

    return <img width={props.width} src={src} className="img-fluid" style={style} />;
};

export default CDNImage;
